import React, { Component } from 'react';
class Error extends Component {
  constructor(props) {
    super(props);
    this.state = {
      started: false,
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({started:true});
    }, 10);
  }

  render() {
    const { started } = this.state;
    let startClass = '';
    if (started) {
      startClass = 'process-started'
    }
    return (
      <div className={`form-finished-container ${startClass}`}>
        <div className="form-success-text">
          <h2>Something went wrong.</h2> <br/>
          <p>
            Please try again. If this problem insists please contact <br/><a href="mailto:support@a-boss.net?Subject=Trials" target="_top">support@a-boss.net</a> <br/><br/>
              <a className="form-try-again" href="/trial">Back to trials</a>
          </p>
        </div>
      </div>
    );
  }
}

export default Error;


// WEBPACK FOOTER //
// src/views/trial/error.js